var $e6be46486a51c27f$exports = {};
$e6be46486a51c27f$exports = {
    "Clear search": `\u{691C}\u{7D22}\u{3092}\u{30AF}\u{30EA}\u{30A2}`
};


export {$e6be46486a51c27f$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
